import React from 'react'

export interface TabButtonProps {
  title: string
  badge?: string | number
  isActive: boolean
  onClick: () => void
  /** Use flex-1 for equal width tabs, flex-shrink-0 for content-sized tabs */
  flexMode?: 'equal' | 'content'
  className?: string
}

export function TabButton({
  title,
  badge,
  isActive,
  onClick,
  flexMode = 'equal',
  className = '',
}: TabButtonProps) {
  const flexClass = flexMode === 'equal' ? 'flex-1' : 'flex-shrink-0'

  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        ${flexClass} p-2 sm:p-3 text-base text-center relative whitespace-nowrap
        transition-colors duration-200
        ${
          isActive
            ? 'text-[#191D23] font-semibold border-b-2 border-green-700'
            : 'text-[#191D23] font-light hover:text-[#191D23]'
        }
        ${className}
      `}
    >
      <span className="inline-flex items-center gap-2">
        {title}
        {badge !== undefined && <TabBadge badge={badge} isActive={isActive} />}
      </span>
    </button>
  )
}

interface TabBadgeProps {
  badge: string | number
  isActive: boolean
}

export function TabBadge({ badge, isActive }: TabBadgeProps) {
  return (
    <span
      className={`inline-flex items-center justify-center px-2 py-0.5 text-xs font-medium rounded-full ${
        isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'
      }`}
    >
      {badge}
    </span>
  )
}
